if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewed extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      this.section = this.closest('.js-section');
      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.productHandle = this.dataset.productHandle;

      this.fetchRecentProducts();
    }

    removeHandle(productHandle) {
      try {
        const list = (localStorage.getItem('recently-viewed') || '')
          .split(',')
          .filter(h => h && h !== productHandle);
        localStorage.setItem('recently-viewed', list.join(','));
      } catch (e) {}
    }

    fetchRecentProducts() {
      let productHandles = null;
      try {
        productHandles = localStorage.getItem('recently-viewed');
      } catch (e) {}

      if (!productHandles) {
        return;
      }

      const productHandlesArray = productHandles
        .split(',')
        .filter(
          productHandle => productHandle && productHandle !== this.productHandle
        );

      if (productHandlesArray.length === 0) {
        return;
      }

      let added = 0;
      let done = 0;

      productHandlesArray.forEach(productHandle => {
        const addRecentProducts = async () => {
          try {
            const productCardResponse = await fetch(
              `${window.Shopify.routes.root}products/${productHandle}?view=card`
            );

            // Product removed or redirected (e.g. to a collection): drop it, never inject a full page
            if (
              !productCardResponse.ok ||
              productCardResponse.redirected ||
              productCardResponse.url.indexOf('/products/') === -1
            ) {
              this.removeHandle(productHandle);
              return;
            }

            const productCardHTML = await productCardResponse.text();
            const parsed = new DOMParser().parseFromString(productCardHTML, 'text/html');

            if (parsed.querySelector('main, footer, header, #MainContent')) {
              this.removeHandle(productHandle);
              return;
            }

            const card = parsed.body.querySelector('card-product') || parsed.body.querySelector('.card-product');
            if (!card) return;

            const productSlide = document.createElement('DIV');
            productSlide.classList.add(
              'swiper-slide',
              'card-product-slider__slide'
            );
            productSlide.innerHTML = parsed.head.innerHTML + parsed.body.innerHTML;

            if (
              !productSlide.querySelector('card-product') ||
              !productSlide.querySelector('.card-product')
            )
              return;

            this.sliderWrapper.append(productSlide);
            added += 1;
          } catch (error) {
            // ignore
          } finally {
            done += 1;
            if (done !== productHandlesArray.length) {
              return;
            }

            if (added === 0) return;

            this.initSlider();
            this.section?.classList.remove('hidden');
          }
        };

        addRecentProducts();
      });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewed);
}
